"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callDurationTranslations = {
    "en": {
        average: "Average",
        maximum: "Maximum",
        callDuration: "Call Duration",
        infoText: "The average and maximum total call length for the specified date range. Call length represents the time between a call entering the Advanced Hunt Group and the call being terminated, it includes all hold and talk times.",
    },
    "de": {
        infoText: "Die durchschnittliche und maximale Gesamtanrufdauer für den festgelegten Datumsbereich. Die Anrufdauer beschreibt die Zeit zwischen dem Eingang des Anrufs in der erweiterten Sammelrufgruppe und der Beendigung des Anrufs, einschließlich aller Halte- und Gesprächszeiten.",
        average: "Durchschnittlich",
        callDuration: "Anrufdauer",
        maximum: "Maximal",
    },
    "nl": {
        infoText: "De gemiddelde en maximale totale gespreksduur voor het gespecificeerde datumbereik. De gespreksduur is de tijd tussen het moment waarop een gesprek de Geavanceerde Belgroep binnenkomt en het gesprek weer wordt beëindigd, inclusief alle wacht- en gesprekstijden.",
        average: "Gemiddeld",
        callDuration: "Duur van de oproep",
        maximum: "Maximaal",
    },
    "it": {
        infoText: "La lunghezza totale media e massima delle chiamate per l'intervallo di date specificato. La lunghezza della chiamata è rappresentata dal tempo che intercorre tra l'entrata della chiamata nel Gruppo di ricerca avanzato e la conclusione della chiamata stessa ed include i tempi di attesa e di conversazione.",
        average: "Medio",
        callDuration: "Durata della chiamata",
        maximum: "Massimo",
    },
    "fr": {
        infoText: "La durée totale moyenne et maximale des appels pour la plage de dates spécifiée. La durée de l’appel représente le temps entre la prise d’un appel dans le Groupe de recherche avancé et la fin de l’appel, elle inclut le temps de mise en attente et le temps conversation.",
        average: "Moyenne",
        callDuration: "Durée de l'appel",
        maximum: "Maximum",
    },
    "es": {
        infoText: "La duración total media y máxima de las llamadas para el intervalo de fechas especificado. La duración de la llamada representa el tiempo transcurrido entre la entrada de una llamada en el Grupo de Línea colectiva Avanzado y la finalización de la misma, e incluye todos los tiempos de espera y de conversación.",
        average: "Promedio",
        callDuration: "Duración de la llamada",
        maximum: "Máximo",
    },
    "ja": {
        infoText: "指定された日付範囲における合計通話時間の平均および最大値。通話時間とは,アドバンストハントグループに通話が入った時点からその通話が終了した時点までの時間のことで,保留時間と会話時間の全てを含みます。",
        average: "平均",
        callDuration: "通話時間",
        maximum: "最長",
    },
    "en-GB": {
        infoText: "The average and maximum total call length for the specified date range. Call length represents the time between a call entering the Advanced Hunt Group and the call being terminated, it includes all hold and talk times.",
        average: "Average",
        callDuration: "Call Duration",
        maximum: "Maximum",
    },
    "ru": {
        average: "Среднее",
        maximum: "Максимальное",
        callDuration: "Длительность Звонка",
        infoText: "The average and maximum total call length for the specified date range. Call length represents the time between a call entering the Advanced Hunt Group and the call being terminated, it includes all hold and talk times.",
    },
};
